export type ModalType = 'variant' | 'attribute';

type Copy = {
  [type in ModalType]: {
    title: { edit: string; add: string };
    description: { edit: string; add: string };
  };
};

export const VARIANT_MODAL_COPY: Copy = {
  variant: {
    title: { edit: 'Edit variant', add: 'Add variant' },
    description: {
      edit: 'Edit the details for your variant to tailor agent’s responses.',
      add: 'Define the details for your new variant to tailor agent’s responses.',
    },
  },
  attribute: {
    title: { edit: 'Edit attribute', add: 'Add attribute' },
    description: {
      edit: 'Edit the details for your attribute to tailor agent’s responses.',
      add: 'Define the details for your new attribute to tailor agent’s responses.',
    },
  },
} as const;
